export const categories = [
  {
    slug: 'health',
    name: '男性健康',
    description: '关注男性身体与心理健康，提供科学的健康管理知识',
    icon: 'ri-heart-pulse-line',
    color: 'accent',
  },
  {
    slug: 'career',
    name: '事业突破',
    description: '职场进阶、创业指南与财富管理，助力事业腾飞',
    icon: 'ri-rocket-line',
    color: 'primary',
  },
  {
    slug: 'relationship',
    name: '情感关系',
    description: '两性沟通、家庭经营与人际关系提升指南',
    icon: 'ri-user-heart-line',
    color: 'secondary',
  },
  {
    slug: 'self-growth',
    name: '自我提升',
    description: '思维方式、习惯养成与个人潜能全面开发',
    icon: 'ri-shield-star-line',
    color: 'accent',
  },
];

export const articles = [
  {
    id: 1,
    category: 'health',
    title: '30岁后男性必做的5项健康检查，别等身体亮红灯',
    excerpt: '随着年龄增长，男性健康面临越来越多的挑战。定期体检不仅能及早发现潜在问题，更是对自己负责的表现。本文为你梳理30岁后必须关注的五项核心检查。',
    content: `## 为什么30岁是关键节点

30岁是男性身体机能开始出现明显变化的分水岭。新陈代谢逐渐放缓，肌肉量开始自然流失，心血管疾病风险逐步升高。许多在20多岁时可以忽视的身体信号，到了30岁就必须认真对待。

## 必须做的5项检查

### 1. 心血管系统检查

包括血压、血脂、血糖三项基本指标。中国心血管疾病发病率持续上升，男性患病率高于女性。建议每年至少检查一次。

**重点关注指标：**
- 血压：理想值应低于120/80mmHg
- 总胆固醇：应低于5.2mmol/L
- 空腹血糖：应低于6.1mmol/L

### 2. 前列腺健康筛查

前列腺问题在30岁以上男性中并不罕见。早期筛查可以通过PSA（前列腺特异性抗原）血液检测和直肠指检进行。

**建议频率：** 30-40岁每2年一次，40岁以上每年一次。

### 3. 肝功能检查

现代男性社交应酬多，饮酒、熬夜等习惯对肝脏负担较大。肝功能检查可以及时发现脂肪肝、肝炎等问题。

### 4. 肿瘤标志物筛查

虽然全面肿瘤筛查建议在40岁以后，但30岁开始建立基准数据非常有价值。重点关注肺癌、肝癌、胃癌等男性高发癌症的标志物。

### 5. 心理健康评估

男性心理健康常常被忽视。焦虑、抑郁、职业倦怠等问题在高压职场环境中十分普遍。建议通过专业量表定期自评。

## 行动起来

健康不是一蹴而就的事，而是日积月累的习惯。从现在开始，给自己制定一个年度体检计划，把健康当作最重要的投资。`,
    image: 'https://readdy.ai/api/search-image?query=Professional%20modern%20medical%20health%20examination%20concept%20with%20masculine%20warm%20amber%20tones%2C%20clean%20clinical%20aesthetic%2C%20soft%20natural%20lighting%2C%20minimalist%20composition%2C%20fitness%20and%20wellness%20theme&width=800&height=500&seq=article-health-01&orientation=landscape',
    readTime: 8,
    date: '2026-08-05',
    author: '健康导师·陈医生',
    tags: ['体检', '心血管', '前列腺', '健康管理'],
  },
  {
    id: 2,
    category: 'health',
    title: '男人也需要保养：科学护肤与抗衰老全攻略',
    excerpt: '男性护肤不再是娘炮的表现，而是基本的自我管理。科学护肤不仅能让你看起来更年轻，更是皮肤健康的重要保障。',
    content: `## 打破偏见：男性护肤的必要性

长期以来，"男人不需要护肤"的刻板印象困扰着许多男性。事实上，男性皮肤与女性皮肤存在显著差异——男性皮肤更厚、油脂分泌更旺盛、更易受紫外线伤害。科学的护肤不仅是外表问题，更是健康问题。

## 男性护肤三步基础法

### 第一步：清洁

选择适合自己肤质的洁面产品。油性皮肤选择控油型，干性皮肤选择保湿型。每天早晚各一次，运动后必须清洁。

### 第二步：保湿

男性皮肤水分流失速度不亚于女性。选择清爽不油腻的保湿产品，含有神经酰胺、透明质酸等成分的产品效果更佳。

### 第三步：防晒

这是最被男性忽视却是最重要的一步。紫外线是皮肤老化的头号元凶。选择SPF30以上的防晒产品，每天使用。

## 进阶抗衰老策略

- **抗氧化精华**：维生素C、维生素E等成分可以帮助抵抗自由基
- **眼霜**：眼周皮肤最薄，最容易显露年龄
- **定期去角质**：每周1-2次，促进皮肤新陈代谢
- **健康生活方式**：充足睡眠、均衡饮食、戒烟限酒`,
    image: 'https://readdy.ai/api/search-image?query=Masculine%20skincare%20and%20grooming%20concept%20with%20clean%20minimal%20aesthetic%2C%20warm%20lighting%2C%20modern%20bathroom%20setting%2C%20sophisticated%20male%20selfcare%2C%20professional%20product%20photography%20style&width=800&height=500&seq=article-health-02&orientation=landscape',
    readTime: 6,
    date: '2026-07-28',
    author: '健康导师·陈医生',
    tags: ['护肤', '抗衰老', '防晒', '男性护理'],
  },
  {
    id: 3,
    category: 'health',
    title: '告别啤酒肚：适合30+男性的高效减脂方案',
    excerpt: '啤酒肚不仅影响形象，更是代谢综合征的危险信号。本文提供一套科学的、专为中年男性设计的减脂方案。',
    content: `## 啤酒肚的真相

腹部脂肪分为皮下脂肪和内脏脂肪两种。啤酒肚主要是内脏脂肪堆积的结果——这种脂肪包裹在内脏周围，比皮下脂肪危险得多，与心血管疾病、糖尿病等密切相关。

男性腰围超过90cm就意味着内脏脂肪超标，需要立即采取行动。

## 饮食调整方案

### 早餐要吃好
- 高蛋白：鸡蛋、希腊酸奶、蛋白粉
- 复合碳水：燕麦、全麦面包、红薯
- 拒绝：油条、甜面包、含糖饮料

### 午餐要吃饱
- 参考"餐盘法"：一半蔬菜、四分之一蛋白质、四分之一碳水
- 选择瘦肉类：鸡胸肉、鱼肉、瘦牛肉
- 烹饪方式：蒸、煮、烤，避免油炸

### 晚餐要吃少
- 以蔬菜和蛋白质为主
- 减少碳水摄入
- 晚餐时间不晚于20:00

## 运动方案

### 力量训练（每周3次）
- 深蹲：3组 × 12次
- 硬拉：3组 × 10次
- 卧推：3组 × 12次
- 引体向上：3组 × 力竭

### 有氧运动（每周2-3次）
- 高强度间歇训练（HIIT）：20分钟
- 或慢跑：40分钟，心率保持在最大心率的65%-75%

## 关键提醒

减脂没有捷径，但也没有想象中的那么难。坚持3个月，你会看到一个全新的自己。`,
    image: 'https://readdy.ai/api/search-image?query=Fit%20masculine%20male%20fitness%20training%20in%20modern%20gym%20with%20warm%20amber%20lighting%2C%20athletic%20body%2C%20motivational%20atmosphere%2C%20clean%20minimalist%20gym%20interior%2C%20professional%20fitness%20photography&width=800&height=500&seq=article-health-03&orientation=landscape',
    readTime: 10,
    date: '2026-07-20',
    author: '健身教练·大刘',
    tags: ['减脂', '健身', '腹肌', '饮食方案'],
  },
  {
    id: 4,
    category: 'career',
    title: '职场中年危机：35岁后如何保持竞争力',
    excerpt: '35岁是很多职场人的焦虑年龄。本文从技能升级、人脉经营、副业探索三个维度，帮你打破职业天花板。',
    content: `## 正视35岁现象

"35岁危机"并非中国特有，全球职场都存在类似现象。但与其焦虑，不如把35岁当作职业发展的第二个黄金期——你有经验、有人脉、有判断力，这些都是20多岁的年轻人不具备的优势。

## 技能升级策略

### 硬技能：拥抱技术变革
- AI工具应用：学会使用ChatGPT、Midjourney等AI工具提升工作效率
- 数据分析：掌握基础的Excel高级功能和SQL
- 行业证书：获取所在行业含金量高的专业认证

### 软技能：不可替代的核心竞争力
- 领导力：从执行者转变为领导者
- 沟通能力：跨部门协调、向上管理
- 战略思维：从全局视角思考问题

## 人脉经营的三个层次

1. **日常维护层**：定期与核心人脉保持联系，不功利
2. **价值输出层**：主动分享行业见解，建立专业影响力
3. **跨界拓展层**：参与不同行业的交流活动，拓展视野

## 副业探索

副业不只是增加收入，更是职业保险。选择与主业互补或能发挥个人兴趣的方向：
- 知识付费：将你的专业经验打包成课程
- 咨询顾问：利用业余时间提供专业咨询服务
- 内容创作：在垂直领域建立个人品牌`,
    image: 'https://readdy.ai/api/search-image?query=Professional%20male%20executive%20in%20modern%20office%20with%20warm%20golden%20lighting%2C%20confident%20posture%2C%20contemporary%20workspace%2C%20career%20success%20concept%2C%20editorial%20business%20photography&width=800&height=500&seq=article-career-01&orientation=landscape',
    readTime: 9,
    date: '2026-08-02',
    author: '职业导师·李总',
    tags: ['职场', '中年危机', '技能升级', '副业'],
  },
  {
    id: 5,
    category: 'career',
    title: '从零开始做副业：适合上班族的5个低门槛方向',
    excerpt: '想增加收入但不知从何下手？本文精选5个适合上班族的副业方向，门槛低、时间灵活、可持续。',
    content: `## 为什么要做副业

主业提供稳定收入，副业提供可能性。在这个充满不确定性的时代，一份靠谱的副业不仅可以增加收入，更能给你带来安全感和更多的选择权。

## 5个低门槛副业方向

### 1. 自媒体内容创作
选择你擅长的领域，持续输出有价值的内容。平台可以选择微信公众号、小红书、抖音等。
- **启动成本**：几乎为零
- **变现方式**：广告、知识付费、带货
- **月收入潜力**：1000-50000+

### 2. 在线技能服务
将你的专业技能打包成服务产品，在猪八戒网、Upwork等平台接单。
- 热门方向：PPT设计、文案写作、视频剪辑、翻译
- **启动成本**：低
- **月收入潜力**：2000-10000+

### 3. 知识付费课程
你不需要是行业顶尖专家，只要比想学的人多懂一些就够了。
- 录制一套入门到进阶的课程
- 平台：得到、小鹅通、荔枝微课

### 4. 电商副业
无需囤货的社交电商或一件代发模式。
- 选品策略：聚焦垂直细分品类
- 平台：拼多多、闲鱼、抖音小店

### 5. 咨询服务
将多年积累的行业经验转化为咨询服务。
- 定价策略：按小时收费，初期可以低价积累案例
- 渠道：知乎、在行、朋友圈

## 副业成功的关键

不在于你选择了什么方向，而在于你是否能坚持至少6个月。90%的人会在前3个月放弃，坚持下来的人就是赢家。`,
    image: 'https://readdy.ai/api/search-image?query=Modern%20male%20freelancer%20working%20on%20laptop%20at%20stylish%20home%20office%20with%20warm%20lighting%2C%20side%20hustle%20concept%2C%20comfortable%20minimalist%20workspace%2C%20motivational%20atmosphere&width=800&height=500&seq=article-career-02&orientation=landscape',
    readTime: 8,
    date: '2026-07-25',
    author: '创业导师·王总',
    tags: ['副业', '自媒体', '知识付费', '电商'],
  },
  {
    id: 6,
    category: 'career',
    title: '谈判力：职场男性必须掌握的核心技能',
    excerpt: '薪资谈判、项目争取、资源协调——职场处处是谈判。掌握谈判技巧，让你的价值得到应有的回报。',
    content: `## 为什么谈判力如此重要

很多职场人对谈判存在误解，认为谈判就是对抗和博弈。实际上，好的谈判是双赢的艺术。你每一次薪资沟通、每一次项目资源争取、每一次跨部门协调，本质上都是谈判。

## 谈判前的准备

### 信息收集
- 了解对方的真实需求和底线
- 掌握行业数据和市场行情
- 明确自己的BATNA（最佳替代方案）

### 目标设定
- 乐观目标：理想情况下希望达成的结果
- 合理目标：经过让步后可以接受的结果
- 底线目标：绝对不能退让的最低标准

## 谈判中的策略

### 锚定效应
第一个提出数字的人往往占据优势。在薪资谈判中，主动给出一个略高于预期的数字作为锚点。

### 沉默的力量
提出要求后，保持沉默。大多数人因为不习惯沉默而主动让步。让对方先开口。

### 条件交换
不要单方面让步。每次让步都要求对方也做出相应让步。"如果你能在这个条件上满足我，我可以在那个条件上做出调整。"

### 情感管理
保持冷静和专业。永远不要因为情绪激动而做出承诺或让步。如果感到情绪上涌，可以请求短暂休息。

## 常见谈判误区

1. 过于急于达成协议
2. 只关注价格/薪资而忽视其他条件
3. 没有准备BATNA就进入谈判
4. 透露底线`,
    image: 'https://readdy.ai/api/search-image?query=Professional%20business%20negotiation%20scene%20with%20two%20men%20in%20suits%2C%20modern%20conference%20room%2C%20warm%20sophisticated%20lighting%2C%20corporate%20elegance%2C%20confident%20handshake%2C%20editorial%20style&width=800&height=500&seq=article-career-03&orientation=landscape',
    readTime: 7,
    date: '2026-07-15',
    author: '职业导师·李总',
    tags: ['谈判', '职场技能', '薪资', '沟通'],
  },
  {
    id: 7,
    category: 'relationship',
    title: '高情商沟通：如何与伴侣有效表达需求',
    excerpt: '很多男性在亲密关系中不擅长表达情感，导致误解和冲突。学会高情商沟通，让你的感情更加稳固。',
    content: `## 男性情感表达的困境

"男人不能示弱"、"有泪不轻弹"——这些传统文化观念让许多男性在情感表达上遇到障碍。然而，亲密关系恰恰需要坦诚的情感交流。不会表达不等于没有情感，学会表达是每个成熟男性应该掌握的技能。

## 非暴力沟通四步法

### 第一步：观察而非评判
- 错误："你总是不关心我"
- 正确："这周你有三天晚上都在加班到很晚"

描述具体的事实和行为，而不是给对方贴标签。

### 第二步：表达感受
- 错误："你让我很生气"
- 正确："我感到有些孤单和失落"

用"我感到"而不是"你让我"，为你的情绪负责。

### 第三步：说出需要
- 明确表达："我需要每周至少有两天晚上我们能一起吃晚饭"
- 含糊表达："我希望你能多陪陪我"

### 第四步：提出请求
- 具体请求："这周六我们一起去那家新开的餐厅吗？"
- 模糊要求："你应该多关心我"

## 男人也需要被理解

男性在关系中同样需要被理解、被尊重、被欣赏。不要觉得表达这些需求就是软弱。真正强大的人敢于面对和表达自己的情感。

## 冲突处理黄金法则

1. 不在情绪激动时做决定
2. 用"我们"代替"我"和"你"
3. 先倾听，再表达
4. 解决问题的目标不是赢，而是理解`,
    image: 'https://readdy.ai/api/search-image?query=Warm%20intimate%20couple%20conversation%20in%20cozy%20modern%20living%20room%20with%20golden%20sunset%20lighting%2C%20emotional%20connection%2C%20masculine%20vulnerability%2C%20cinematic%20warm%20tones&width=800&height=500&seq=article-relation-01&orientation=landscape',
    readTime: 7,
    date: '2026-08-01',
    author: '情感导师·周老师',
    tags: ['沟通', '亲密关系', '高情商', '情感表达'],
  },
  {
    id: 8,
    category: 'relationship',
    title: '当父亲是一门艺术：新手爸爸的必修课',
    excerpt: '成为父亲是人生最重要的角色转变之一。本文从陪伴、教育、榜样三个角度，帮助新手爸爸快速进入角色。',
    content: `## 父亲的独特价值

研究表明，父亲在育儿中的参与度对孩子的认知发展、社交能力和情绪管理有着母亲无法替代的积极影响。你的存在本身，就是孩子成长中最重要的资源之一。

## 陪伴的质量胜过数量

### 高质量陪伴的三个标准
1. **全身心投入**：放下手机，关掉电视，这段时间只属于你和孩子
2. **有互动**：不是坐在旁边看孩子玩，而是参与到孩子的世界中去
3. **有情感交流**：让孩子感受到你的爱和关注

### 不同年龄段的陪伴重点
- **0-3岁**：多抱抱、多说话、多陪玩
- **3-6岁**：开始建立规则意识，多户外活动
- **6-12岁**：培养兴趣爱好，成为孩子的玩伴和导师

## 做孩子的榜样

孩子不看你怎么说，只看你怎么做。
- 你怎么对待妻子，就是教孩子如何对待异性
- 你怎么面对困难，就是教孩子如何应对挫折
- 你怎么对待工作，就是教孩子什么是责任

## 平衡工作与家庭

- 设定不可动摇的家庭时间（如周末全天）
- 高质量的15分钟胜过敷衍的2小时
- 让妻子感受到你的支持和参与`,
    image: 'https://readdy.ai/api/search-image?query=Warm%20father%20and%20child%20moment%20in%20golden%20sunset%20park%2C%20masculine%20parenting%2C%20tender%20family%20scene%2C%20natural%20soft%20lighting%2C%20emotional%20cinematic%20photography&width=800&height=500&seq=article-relation-02&orientation=landscape',
    readTime: 8,
    date: '2026-07-22',
    author: '情感导师·周老师',
    tags: ['父亲', '育儿', '家庭', '榜样'],
  },
  {
    id: 9,
    category: 'self-growth',
    title: '早起的力量：一个改变人生的简单习惯',
    excerpt: '几乎所有成功人士都有一个共同的习惯——早起。这不仅是时间管理问题，更是一种生活态度和自我掌控力的体现。',
    content: `## 早起的魔力

早晨5点到7点是一天中最不受打扰的黄金时间。没有工作消息、没有社交媒体的诱惑、没有家人的需求——这段时间完全属于你自己。

## 早起的好处

### 心理层面
- 获得对生活的掌控感
- 减少焦虑和匆忙感
- 拥有专门用于自我提升的时间

### 生理层面
- 与人体生物钟更协调
- 早晨的空气质量最好
- 规律作息改善睡眠质量

### 效率层面
- 大脑经过一夜休息后最清醒
- 可以进行深度工作
- 为一天定下积极的基调

## 如何养成早起习惯

### 第一阶段：调整入睡时间（第1-2周）
不要急于提前起床时间，先确保每天在固定时间入睡。目标是每天23:00前上床。

### 第二阶段：逐步提前（第3-4周）
每周将闹钟提前15分钟，直到达到目标时间。

### 第三阶段：建立晨间仪式（第5周起）
- 5:30 起床，喝一杯温水
- 5:40 冥想或深呼吸10分钟
- 5:50 阅读30分钟
- 6:20 运动30分钟
- 6:50 洗漱准备开始一天

## 常见问题

**Q: 我晚上效率更高，一定要早起吗？**
A: 每个人的生物钟确实不同。但早起习惯的价值不仅在于效率，更在于自律和掌控感。如果你确实更适应晚睡，可以尝试晚起方案，关键是保持规律。`,
    image: 'https://readdy.ai/api/search-image?query=Early%20morning%20masculine%20lifestyle%20scene%20with%20man%20reading%20by%20window%2C%20golden%20sunrise%20light%2C%20warm%20cozy%20minimalist%20bedroom%2C%20peaceful%20morning%20routine%2C%20motivational%20atmosphere&width=800&height=500&seq=article-growth-01&orientation=landscape',
    readTime: 6,
    date: '2026-07-30',
    author: '成长导师·林教练',
    tags: ['早起', '习惯养成', '自律', '时间管理'],
  },
  {
    id: 10,
    category: 'self-growth',
    title: '深度阅读：在这个碎片化时代重建专注力',
    excerpt: '短视频和碎片化信息正在摧毁我们的专注力。深度阅读是最好的解药——它让我们重新学会思考和专注。',
    content: `## 我们正在失去什么

平均每人每天查看手机超过150次，每次专注时间不超过40秒。持续的信息轰炸让我们的注意力被切割成无数碎片。深度思考的能力——人类最宝贵的认知能力——正在被系统性地削弱。

## 深度阅读的独特价值

### 建立知识体系
碎片化阅读给你的是信息点，深度阅读给你的是知识网。一本好书能帮你建立一个领域的完整认知框架。

### 训练专注力
持续阅读1小时以上是一种专注力训练。就像肌肉需要锻炼一样，专注力也需要刻意练习。

### 培养独立思考
在安静阅读中，你才有机会与作者深度对话，形成自己的判断和见解。而不是被算法推荐的观点带着走。

## 重建深度阅读习惯的实践方案

### 第一步：创造阅读环境
- 设置固定的阅读时间和地点
- 手机放在另一个房间
- 泡一杯茶或咖啡作为仪式感

### 第二步：从感兴趣的开始
不要一开始就挑战难懂的大部头。选择你真正感兴趣的主题，先建立阅读的快感和成就感。

### 第三步：建立输出机制
- 读完每本书写一篇读书笔记
- 在社群中分享你的收获
- 把学到的知识讲给别人听

## 推荐书单

1. 《思考，快与慢》—— 了解你的大脑如何做决策
2. 《原子习惯》—— 小习惯带来大改变
3. 《非暴力沟通》—— 学会真正有效的沟通
4. 《高效能人士的七个习惯》—— 经典中的经典
5. 《刻意练习》—— 成为任何领域的高手`,
    image: 'https://readdy.ai/api/search-image?query=Masculine%20reading%20moment%20in%20cozy%20library%20study%20with%20warm%20amber%20lighting%2C%20leather%20armchair%2C%20bookshelves%2C%20focused%20atmosphere%2C%20sophisticated%20intellectual%20vibe&width=800&height=500&seq=article-growth-02&orientation=landscape',
    readTime: 7,
    date: '2026-07-18',
    author: '成长导师·林教练',
    tags: ['阅读', '专注力', '深度思考', '书单'],
  },
  {
    id: 11,
    category: 'self-growth',
    title: '从自卑到自信：一个普通男人的逆袭之路',
    excerpt: '自信不是天生的，而是可以通过正确方法培养的。分享我个人的成长经历和5个行之有效的自信建立方法。',
    content: `## 我的故事

三年前的我，体重90公斤，月薪5000，不敢在会议上发言，不敢追求喜欢的女生。我总觉得别人都比我优秀，我只是一个普通的、甚至有些失败的男人。

现在的我，体重72公斤，年薪翻了三倍，组建了自己的小团队，也有了稳定的亲密关系。这一切改变的起点，是我决定停止自我否定。

## 自信的真正来源

自信不是"我很厉害"的自恋，而是"我知道自己是谁、我能做什么、我的价值在哪里"的清晰认知。

## 建立自信的5个方法

### 1. 从身体开始
去健身。不一定要练出腹肌，但当你看到自己的身体一天天变强，那种掌控感会渗透到生活的每个角落。

### 2. 积累小胜利
不要一开始就设定宏大的目标。从每天早上叠被子、连续一周不迟到这样的小事开始。每完成一件事，都在告诉自己"我能做到"。

### 3. 学习一项专业技能
找到一项你想掌握的技能，持续投入6个月。当你成为某个领域的"相对专家"时，自信自然而来。

### 4. 改善外表
不是虚荣，而是尊重。得体的穿着、清爽的发型、干净的指甲——这些基础的外在管理会让你在面对他人时更加从容。

### 5. 加入一个正向社群
环境对人的影响远超我们的想象。加入男人团这样的正向社群，与志同道合的兄弟一起成长，互相激励。

## 写在最后

自信不是终点，而是一个持续的过程。即使现在的我，偶尔也会有自我怀疑的时候。区别在于，我不再让这种怀疑定义我。`,
    image: 'https://readdy.ai/api/search-image?query=Confident%20masculine%20man%20looking%20at%20city%20skyline%20at%20sunset%2C%20transformation%20journey%2C%20success%20and%20achievement%2C%20warm%20golden%20hour%20lighting%2C%20motivational%20atmosphere%2C%20cinematic%20portrait&width=800&height=500&seq=article-growth-03&orientation=landscape',
    readTime: 8,
    date: '2026-07-10',
    author: '社群成员·阿杰',
    tags: ['自信', '成长故事', '健身', '自我认知'],
  },
  {
    id: 12,
    category: 'health',
    title: '睡眠革命：高质量睡眠是男人最好的补药',
    excerpt: '睡眠不足正在悄悄摧毁你的睾酮水平、认知能力和情绪稳定。学会科学睡眠，为你的健康和表现充电。',
    content: `## 睡眠对男性的特殊重要性

睡眠对每个人都重要，但对男性尤其关键。研究表明，睡眠不足会直接导致睾酮水平下降。连续一周每天只睡5小时，睾酮水平会下降10%-15%——相当于让你老了10-15岁。

## 睡眠的四大核心功能

### 1. 激素调节
深度睡眠阶段是睾酮和生长激素分泌的高峰期。这些激素对肌肉生长、脂肪代谢、性功能和整体精力都至关重要。

### 2. 认知修复
睡眠期间，大脑会清理代谢废物，巩固记忆。充足的睡眠能提升决策力、创造力和情绪调节能力。

### 3. 身体恢复
深度睡眠时，身体修复受损组织，增强免疫系统。这也解释了为什么长期睡眠不足的人更容易生病。

### 4. 情绪稳定
睡眠不足会放大杏仁核（大脑的恐惧中枢）的活跃度，让你更容易焦虑和暴躁。

## 优化睡眠的实用技巧

### 睡前准备（睡前1小时）
- 屏幕调至夜间模式或完全远离屏幕
- 室内灯光调暗，色温偏暖
- 洗个热水澡（体温先升后降有助于入睡）
- 做一些轻度拉伸或冥想

### 睡眠环境优化
- 温度：18-22°C最适宜
- 光线：越暗越好，使用遮光窗帘
- 声音：白噪音可以掩盖环境噪音
- 床品：投资一套好床垫和枕头

### 如果必须熬夜
- 第二天不要睡太久来补觉（不超过平时+2小时）
- 中午小憩20分钟，不要超过30分钟
- 第二天晚上恢复正常作息`,
    image: 'https://readdy.ai/api/search-image?query=Peaceful%20dark%20bedroom%20with%20masculine%20interior%20design%2C%20soft%20moonlight%2C%20comfortable%20bed%2C%20sleep%20wellness%20concept%2C%20calm%20serene%20atmosphere%2C%20warm%20minimal%20aesthetic&width=800&height=500&seq=article-health-04&orientation=landscape',
    readTime: 7,
    date: '2026-07-08',
    author: '健康导师·陈医生',
    tags: ['睡眠', '睾酮', '健康管理', '精力管理'],
  },
];

export const faqs = [
  {
    question: '男人团是什么？',
    answer: '男人团是一个专为现代男性打造的成长型社群平台。我们聚焦男性健康、事业发展、情感关系和自我提升四大领域，通过高质量的内容、专业的指导和志同道合的社群力量，帮助每一位男性成为更好的自己。',
  },
  {
    question: '如何加入男人团社群？',
    answer: '你可以通过页面底部的联系表单提交申请，我们的社群运营团队会在24小时内与你取得联系。目前社群采用邀请制，我们会根据你的需求和兴趣匹配最适合的社群小组。',
  },
  {
    question: '男人团社群有什么活动？',
    answer: '我们定期举办线上线下活动，包括：每周主题分享会、月度线下交流会、季度成长训练营、年度峰会等。此外还有健身打卡、阅读挑战、早起计划等日常活动。',
  },
  {
    question: '加入社群需要付费吗？',
    answer: '基础社群免费开放，所有人都可以参与日常讨论和活动。我们也提供高级会员服务，包含专属课程、一对一导师指导和私密小群交流等增值服务。',
  },
  {
    question: '女人可以加入男人团吗？',
    answer: '男人团的核心定位是服务男性群体，但我们欢迎女性用户通过特定渠道参与讨论，比如两性关系话题、家庭教育讨论等。部分活动和课程对所有人开放。',
  },
  {
    question: '如何成为男人团的导师或内容贡献者？',
    answer: '如果你在健康、事业、情感或自我提升领域有专业背景和实战经验，欢迎通过联系表单提交申请，备注"导师申请"，我们会安排专人与你对接。',
  },
];

export const testimonials = [
  {
    name: '阿强',
    age: 32,
    role: '互联网产品经理',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20headshot%2C%20friendly%20smile%2C%20simple%20clean%20background%2C%20warm%20tone&width=100&height=100&seq=avatar-01&orientation=squarish',
    content: '加入男人团三个月，我不仅成功减掉了10公斤，还在社群里找到了一起创业的合伙人。这里不只是社群，更是一个让我重新认识自己的地方。',
  },
  {
    name: '老周',
    age: 38,
    role: '企业中层管理',
    avatar: 'https://readdy.ai/api/search-image?query=Mature%20Chinese%20male%20portrait%20headshot%2C%20confident%20expression%2C%20simple%20background%2C%20professional%20look&width=100&height=100&seq=avatar-02&orientation=squarish',
    content: '最打动我的是这里没有虚假的正能量，大家都是真实的男人，分享真实的困惑和成长。在职场上打拼这么多年，终于找到一个可以说真话的地方。',
  },
  {
    name: '小林',
    age: 27,
    role: '自由职业者',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20male%20portrait%20headshot%2C%20warm%20smile%2C%20casual%20style%2C%20simple%20background%2C%20fresh%20look&width=100&height=100&seq=avatar-03&orientation=squarish',
    content: '作为一个刚毕业没几年的年轻人，男人团给了我很多前辈的指导和建议。尤其是职业规划方面的内容，让我少走了很多弯路。',
  },
];